import apiClient from "./apiClient";
import jquery from 'jquery'
/**
 * For Making get Requests
 */
const getApi = (url, params) => {
  return apiClient.get(url, { params });
};

/**
 * For Making Post Request
 */
const postApi = (url, data, transformed) => {
  if (transformed) {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    data = jquery.param(data)
    return apiClient.post(url, data, config);
  }

  return apiClient.post(url, data);
};

/**
 * For Making put Request
 */
const putApi = (url, data, transformed) => {
  if (transformed) {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    // Serialize params https://github.com/knowledgecode/jquery-param
    // data = JquerParam(data)

    return apiClient.put(url, data, config);
  }

  return apiClient.put(url, data);
};

/**
 * For Making Delete Request
 */
const deleteApi = (url, params) => {
  return apiClient.delete(url, { params });
};

export { getApi, postApi, putApi, deleteApi };
